<template>
    <el-row v-loading="loading" style="margin-bottom: 15px">
        <el-row class="padding_5px_top padding_10px_bottom">
            <el-col style="width: 350px; margin-top: 5px">
                <el-col :span="6" class="fundSelector_tab"> 基金类型： </el-col>
                <el-col :span="16" class="left_text_align">
                    <el-select
                        class="fundSelector_Company"
                        v-model="categoryName"
                        filterable
                        clearable
                        collapse-tags
                        @visible-change="loadingData($event, categoryName)"
                        @clear="refreshAll(categoryName)"
                        multiple
                        placeholder="全部类型"
                        :filter-method="fiterCategory"
                    >
                        <el-option
                            v-for="item in filteredCategoryList"
                            :key="item.categoryName"
                            :label="item.categoryName"
                            :value="item.categoryName"
                        >
                        </el-option>
                    </el-select>
                </el-col>
            </el-col>
            <el-col :span="1" class="left_text_align" style="margin-top: 5px">
                <el-button
                    type="primary"
                    size="medium"
                    style="height: 38px"
                    @click="refresh()"
                    >确定</el-button
                >
            </el-col>
        </el-row>
        <div class="line"></div>
        <el-table
            :data="tableData"
            @sort-change="sortChange"
            :default-sort="{ prop: 'defaultSymbol', order: 'descending' }"
            style="width: 100%; margin-top: 5px"
        >
            <el-table-column
                fixed
                type="index"
                label="序号"
                width="60"
            ></el-table-column>
            <el-table-column
                fixed
                sortable="custom"
                prop="symbol"
                label="基金代码"
                width="110"
            >
            </el-table-column>
            <el-table-column
                fixed
                sortable="custom"
                prop="className"
                label="基金名称"
                width="241"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                sortable="custom"
                prop="categoryName"
                label="晨星分类"
                width="150"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                sortable="custom"
                prop="managerName"
                label="基金经理"
                width="150"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                sortable="custom"
                prop="companyName"
                label="基金公司"
                width="150"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                prop="ratingRank"
                sortable="custom"
                label="晨星定性评级"
                width="150"
            >
                <template slot-scope="scope">
                    <span class="margin-left-20-important">
                        <!-- <img
            v-if="scope.row.ratingRank == 2"
            :src= "analystRatingSilver"
          />
          <el-image
            v-if="scope.row.ratingRank == 1"
            style="width: 50px; height: 30px"
            src= "../../public/images/smallstar0.gif">
          </el-image> -->
                        <span
                            v-if="scope.row.ratingRank == 1"
                            class="analyst-rating-icon"
                            v-html="analystRatingGold"
                        />
                        <span
                            v-if="scope.row.ratingRank == 2"
                            class="analyst-rating-icon"
                            v-html="analystRatingSilver"
                        />
                        <span
                            v-if="scope.row.ratingRank == 3"
                            class="analyst-rating-icon"
                            v-html="analystRatingBronze"
                        />
                        <span
                            v-if="scope.row.ratingRank == 4"
                            class="analyst-rating-text-icon"
                            v-html="analystRatingNeutral"
                        />
                        <span
                            v-if="scope.row.ratingRank == 5"
                            class="analyst-rating-text-icon"
                            v-html="analystRatingNegative"
                        />
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                prop="effectiveDate"
                label="评级时间"
                min-width="130"
            >
                <template slot-scope="scope">
                    {{ scope.row.effectiveDate | replaceTime }}
                </template>
            </el-table-column>
            <!--<el-table-column
        prop="targetFolder"
        label="报告下载"
        width="120px"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            @click="
                            downloadFile({
                                type: 'ftpFile',
                                url: scope.row.targetFolder,
                                fileName: scope.row.className,
                            })
                        "
            size="small"
          >下载</el-button>
        </template>
      </el-table-column>-->
        </el-table>
        <el-col class="left_text_align padding_25px_top">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="params.page"
                :page-sizes="[10, 20, 50, 100, 200]"
                :page-size="pagination.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="(pagination && pagination.count) || 0"
                v-if="pagination.count > 10 ? true : false"
            >
            </el-pagination>
        </el-col>
    </el-row>
</template>
<script>
import { Message } from "element-ui";
import { getLatestAnalystRatingFund } from "../../api/analystRating";
import { fiterCategory } from "./mixin/analystRatingCategory";
import analystRatingGold from "../../public/images/Gold-Q.svg";
import analystRatingSilver from "../../public/images/Silver-Q.svg";
import analystRatingBronze from "../../public/images/Bronze-Q.svg";
import analystRatingNeutral from "../../public/images/Neutral-Q.svg";
import analystRatingNegative from "../../public/images/Negative-Q.svg";
const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;

export default {
    mixins: [fiterCategory],
    data() {
        return {
            categoryName: "",
            exportDialogVisible: false,
            exportDialogLoading: false,
            symbol: "",
            searchPopoverVisible: false,
            downloadAllVisible: false,
            dialogLoading: false,
            symbolList: [],
            configSendDialogVisible: false,
            importDialogVisible: false,
            exportDialogVisible: false,
            ftpDialogVisible: false,
            loading: false,
            tableData: [],
            pageSize: 0,
            selectFormat: "xlsx",
            initialized: false,
            pagination: {
                skip: 0,
                limit: 10,
                count: 0,
            },
            params: {
                sort: "",
                order: "",
                limit: 10,
                skip: 0,
                page: 1,
                categoryName: "",
            },
            analystRatingGold,
            analystRatingSilver,
            analystRatingBronze,
            analystRatingNeutral,
            analystRatingNegative,
        };
    },
    filters: {
        mapAnalystRating(value) {
            let result = "";
            switch (value) {
                case "Bronze":
                    result = "AR-C";
                    break;
                case "Silver":
                    result = "AR-B";
                    break;
                case "Gold":
                    result = "AR-A";
                    break;
                default:
                    result = "--";
            }
            return result;
        },
        fillNull(value) {
            if (value != undefined && value != null && value != "") {
                return value;
            } else {
                return "--";
            }
        },
        replaceTime(value) {
            if (value != undefined && value != null && value != "") {
                return value.replace("00:00:00.0", "");
            } else {
                return "--";
            }
        },
    },
    mounted() {
        const self = this;
        self.getData();
        self.handleFundCategory();
    },
    watch: {},
    methods: {
        init() {
            const self = this;
            if (!self.initialized) {
                self.getData();
                self.handleFundCategory();
                self.initialized = true;
            }
        },

        loadingData(callback, categoryName) {
            const self = this;
            if (!callback) {
                if (
                    self.params.categoryName != undefined &&
                    self.params.categoryName != ""
                ) {
                    let sortedCategroyName = categoryName
                        .sort((a, b) => a - b)
                        .toString();
                    if (
                        sortedCategroyName !=
                        self.params.categoryName.toString()
                    ) {
                        self.params.categoryName = sortedCategroyName;
                        self.getData();
                    }
                } else if (self.params.categoryName != categoryName) {
                    self.params.categoryName = categoryName.toString();
                    self.getData();
                }
            }
        },
        refresh() {
            const self = this;
            let sortedCategroyName = self.categoryName
                .sort((a, b) => a - b)
                .toString();
            if (sortedCategroyName != self.params.categoryName.toString()) {
                self.params.categoryName = sortedCategroyName;
                self.getData();
            }
        },
        refreshAll(categoryName) {
            const self = this;
            if (self.params.categoryName != categoryName) {
                self.params.categoryName = categoryName.toString();
                self.getData();
            }
        },
        getData() {
            const self = this;
            self.loading = true;
            getLatestAnalystRatingFund(self.params)
                .then((response) => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000,
                        });
                        Message.close = function () {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000,
                                });
                                Message.close = function () {};
                            } else {
                                self.pagination = result.pagination;
                                self.pageSize = result.pagination.count;
                                self.tableData = result.data.analystRatingFund;
                            }
                        }
                    }
                })
                .catch((err) => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000,
                    });
                    Message.close = function () {};
                })
                .finally((r) => {
                    self.loading = false;
                });
        },
        handleSizeChange(val) {
            const self = this;
            self.params.limit = val;
            self.getData(self.params);
        },
        handleCurrentChange(val) {
            const self = this;
            self.params.page = val;
            self.params.skip = (val - 1) * self.params.limit;
            self.getData(self.params);
        },
        sortChange(column, prop, order) {
            let self = this;
            if (column.order != undefined) {
                self.params.order = column.order
                    .replace("ascending", "asc")
                    .replace("descending", "desc");
                self.params.sort = column.prop;
                self.getData(self.params);
            }
            console.log(column + "-" + column.prop + "-" + column.order);
        },
    },
};
</script>
<style lang="scss">
@import "../../public/sass/components/analystRating";

.analyst-rating-icon {
    height: 60px;
    width: 30px;
    & > svg {
        width: 60px;
        height: 30px;
    }
}
.analyst-rating-text-icon {
    height: 60px;
    width: 30px;
    & > svg {
        width: 60px;
        height: 30px;
        padding-left: 26px;
    }
}
.el-select__tags {
    flex-wrap: nowrap !important;
}
</style>
